/**
 * WARNING WARNING WARNING
 *
 * Usage of memoizeDeep can be dangerous: it can greatly improve
 * rendering of similar components on the same page (think multiple
 * primary buttons) by caching the themes. On the other hand, there
 * is a cost to cache all those properties, therefore it should not
 * be used lightly. A component that is rarely used (Footer,
 * Masthead, etc.) should not use this optimization.
 *
 * Key concepts to remember: memoizeDeep will cache arguments, even
 * if they are part of an object, so make sure that object is not
 * too deep. For example, passing the full theme to memoizeDeep would
 * be criminal (the theme.components contains ALL the components).
 *
 * Another key concept is that only native keys should be used:
 *
 * GOOD:
 * memoizeDeep(function({
 *  aaa, // -> boolean
 *  bbb, // -> string
 *  ccc, // -> number
 *  ddd, // -> simple object
 * }));
 *
 * BAD:
 * memoizeDeep(function({
 *  aaa, // -> JSX object
 *  bbb, // -> Deep nested objet
 *  ccc, // -> function
 * }));
 *
 */
import { memoizeDeep } from "../../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    megamenuitem
  } = _ref;
  let cssRoot = {},
      megaMenuItem = {};

  if (megamenuitem) {
    cssRoot = megamenuitem.root;
    megaMenuItem = megamenuitem.megaMenuItem;
  }

  return {
    cssRoot,
    megaMenuItem
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme
  } = _ref2;
  const megamenuitem = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.megamenuitem;
  return setTheme({
    megamenuitem
  });
}